module.exports = __webpack_public_path__ + "img/sfz1.png";